import '../../themes/merchant/borderRadius/index.js';
import '../../themes/merchant/borderWidth/index.js';
import { CloseSides } from '../modal/constants.js';
import { NavigationAlignments } from '../sidesheet/constants.js';
import '../../themes/merchant/color/index.js';
import { TextStyleSemanticsAll } from '../../themes/merchant/textStyle/textStyle-semantics.js';
import '../../themes/merchant/shape/index.js';
import '../../themes/merchant/size/index.js';
import '../../themes/merchant/spacing/index.js';
import { BorderRadiusSemanticsAll } from '../../themes/merchant/borderRadius/borderRadius-semantics.js';
import { BorderWidthSemanticsAll } from '../../themes/merchant/borderWidth/borderWidth-semantics.js';
import { ColorSemanticsAll } from '../../themes/merchant/color/color-semantics.js';
import { ShapeSemanticsAll } from '../../themes/merchant/shape/shape-semantics.js';
import { SizeSemanticsAll } from '../../themes/merchant/size/size-semantics.js';
import { SpacingSemanticsAll } from '../../themes/merchant/spacing/spacing-semantics.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MerchantOverrides = {
  BorderRadius: _objectSpread({}, BorderRadiusSemanticsAll),
  BorderWidth: _objectSpread({}, BorderWidthSemanticsAll),
  Colors: _objectSpread({}, ColorSemanticsAll),
  Modal: {
    closeButtonSide: CloseSides.Trailing,
    hasDynamicPadding: true,
    titleSize: 24,
    useHairlineDividers: true
  },
  Popover: {
    showContainerPointer: false
  },
  Shape: _objectSpread({}, ShapeSemanticsAll),
  Sidesheet: {
    navigationAlignment: NavigationAlignments.Trailing,
    shouldUseDynamicPadding: true,
    panelWidths: {
      Mobile: '100vw',
      Tablet: '375px',
      Desktop: '480px',
      WideScreen: '560px',
      UltraWideScreen: '560px'
    }
  },
  Size: _objectSpread({}, SizeSemanticsAll),
  Spacing: _objectSpread({}, SpacingSemanticsAll),
  Typography: {
    TextStyles: _objectSpread({}, TextStyleSemanticsAll)
  }
};

export { MerchantOverrides };
